<template>
	<div class="jrhy">
		<div style="background:  #127DEF;">
			<div class="heyan">
				<div>
					欢&nbsp;&nbsp;迎&nbsp;&nbsp;使&nbsp;&nbsp;用&nbsp;&nbsp;金&nbsp;&nbsp;融&nbsp;&nbsp;类&nbsp;&nbsp;电&nbsp;&nbsp;子&nbsp;&nbsp;证&nbsp;&nbsp;据&nbsp;&nbsp;查&nbsp;&nbsp;询
				</div>
				<input type="text" class="cxrk_input" v-model.trim="sfzhNum" placeholder="请输入身份证号/手机号" />
				<button @click="chaxun()">立即查询</button>

				<!-- 查无信息，请检查输入号码是否正确 该身份无仲裁信息-->
				<p class="cxrk_div_err" v-if="cwxx">* 查无信息，请检查输入号码是否正确！</p>
				<p class="cxrk_div_err" v-if="qsrsfzh">* 请输入身份证号！</p>
			</div>
		</div>
		<!-- 查看pdf弹框 -->
		<div class="cjscktc_modul" v-if="pdfmodul">
			<div class="cjscktc">
				<div class="cjscktc_title">请选择要查看的文档</div>
				<div class="cjscktc_con">
					<div style="margin-bottom: 20px;display: flex;padding-left: 90px;" v-for="(item, index) in pdfInfos" :key="index">
						<a :href="item.url" target="_blank">
							<span style="text-decoration: underline;color:rgb(18, 125, 239)">电子证据材料{{ index + 1 }}>>></span>
						</a>
					</div>
				</div>
				<div class="cjscktc_bottom"><p style="color: #858787;" @click="(pdfmodul = false), (cjsInd = 0)">取消</p></div>
			</div>
		</div>
		<!-- 裁决书查看弹框 -->
		<div class="cjscktc_modul" v-if="cjscmodul">
			<div class="cjscktc">
				<div class="cjscktc_title">请选择相关企业核验</div>
				<div class="cjscktc_con">
					<div style="margin-bottom: 20px;display: flex;padding-left: 90px;" v-for="(item, index) in cjsLIst" :key="index">
						<div>
							<p>
								<el-radio-group @change="radioChange(item)" v-model="radioVal">
									<el-radio :label="item.cid">{{ item.to_title }}</el-radio>
								</el-radio-group>
							</p>
							<p v-if="item.security_lvl == 2 && item.cid == radioVal">需输入核验通知短信中的验证码</p>
						</div>
						<div class="textInput" v-if="item.security_lvl == 2 && item.cid == radioVal"><input type="text" v-model="cJcode" placeholder="请输入验证码" /></div>
						<!-- <p :class="cjsInd==index?'cjscktc_con_p_act':''" @click="djcjs(item.cid,index,item.type)" :title="item.to_title"
					 v-text="item.to_title.length>17?item.to_title.substr(0,17)+'...':item.to_title"></p> -->
					</div>
				</div>
				<div class="cjscktc_bottom">
					<p style="color: #858787;" @click="(cjscmodul = false), (cjsInd = 0)">取消</p>
					<p style="margin-right: 0px;background: #127DEF;border: 1px solid #127DEF;border-radius: 2px;color: #FFFFFF;" @click="qdcjs()">确定</p>
				</div>
			</div>
		</div>
		<div class="liucheng">
			<div>
				<ul>
					<span>■ 法院核验入口</span>
				</ul>
				<div class="fuwu">
					<ul>
						<li v-for="(item, index) in fuwuList" :key="index">
							<div @click="fayuan(item.url)">
								<img :src="item.img" />
								<br />
								<span v-html="item.name"></span>
							</div>
						</li>
						<li class="reversal">
							<div class="face">
								<img :src="imgfayuan" />
								<br />
								<span v-html="shengzhen"></span>
							</div>
							<div class="back">
								<img style="width:120px;height:120px;padding:10px;float:left;" :src="src" />
								<br />
								<span style="text-align:center;word-break:normal;display:block;white-space:pre-wrap;overflow:hidden;" v-html="shengzhen"></span>
							</div>
						</li>
						<li>
							<div>
								<img :src="imgfayuan" />
								<br />
								<span v-html="geengduofa"></span>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import '../assets/css/jrhy.less';
export default {
	name: 'index',
	data() {
		return {
			radioVal: '',
			cJcode: '',
			pdfInfos: [],
			pdfmodul: false,
			active: false,
			src: require('../../images/pc_code@2x.png'),
			activeNum: 0,
			cwxx: false,
			qsrsfzh: false,
			cjscmodul: false, //相关企业核验
			sfzhNum: '',
			imgfayuan: require('../../images/logo@2x.png'),
			shengzhen: '深圳市中级人民法院移动微法院',
			geengduofa: '更多合作法院陆续上线中',
			// HTP: 'http://hpf.lvjinhui.cn/',// 测试
			HTP: 'http://of-api.lvjinhui.cn/', // 正式
			fuwuList: [
				{
					name: '吉林省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://evidence.e-court.gov.cn/'
				},
				{
					name: '山东省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://evidence.sdcourt.gov.cn/sdgy/'
				},
				{
					name: '青海省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://evidence.qhwsfy.gov.cn'
				},
				{
					name: '广西省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://evidence.gxcourt.gov.cn/'
				},
				{
					name: '河南省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://188.131.232.156/hnzzzy/'
				},
				{
					name: '浙江省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://188.131.232.156/zjgy/'
				},
				{
					name: '黑龙江省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://188.131.232.156/hebzy/'
				},
				{
					name: '四川省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://pdfy.evidence.bjzjtp.com'
				},
				{
					name: '湖南省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://188.131.232.156/hnldlxfy/'
				},
				{
					name: '安徽省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://188.131.232.156/ssfy/'
				},
				{
					name: '江苏省法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://188.131.232.156/jssyfy/'
				},
				{
					name: '重庆市法院电子证据平台',
					img:require('../../images/logo@2x.png'),
					url: 'http://188.131.232.156/ljxqfy/'
				},
				{
					name: '北京互联网法院',
					img:require('../../images/logo@2x.png'),
					url: 'https://tpl.bjinternetcourt.gov.cn/index.html#/pcSearch'
				}
			]
		};
	},
	methods: {
		doSomething() {
			this.active = true;
		},
		fayuan(url) {
			window.open(url);
		},
		qdcjs() {
			sessionStorage.setItem('radioVal', this.radioVal);
			sessionStorage.setItem('cJcode', this.cJcode);
			var params = new URLSearchParams();
			params.append('cid', this.radioVal);
			params.append('code', this.cJcode);
			params.append('type', this.rType);
			axios.post(this.HTP + 'online_finance/Arbitration/arbTfzCheckCode', params).then(
				res => {
					this.cwxx = false;
					this.qsrsfzh = false;
					if (res.data.code == 200) {
						var params = new URLSearchParams();
						params.append('cid', this.radioVal);
						var hz = 'online_finance/Arbitration/ardTfzTpDetailsZs'
						if(this.rType == 5 || this.rType == 6){
							hz = 'online_finance/Arbitration/ardTfzTpDetails4'
							params.append('type', this.rType);
						}
						axios.post(this.HTP + hz, params).then(
							res => {
								this.cjscmodul = false;
								// this.pdfmodul = true;
								this.pdfInfos = res.data.data.all;
								sessionStorage.setItem('pdfInfos',JSON.stringify(this.pdfInfos))
								this.$router.push({
									path: '/backstage'
								})
							},
							err => {}
						);
						return
						this.cjsInd = 0;
						this.cjscmodul = false;
						if (this.typecz == 1) {
							this.url = 'http://jxtj.sfjdzx.org.cn/cjs1?typeCX=' + this.typecz + '&Encrypt=' + sessionStorage.getItem('Encrypt');
							window.location.href = this.url;
							// this.$router.push({
							// 	path: '/cjs'
							// })
							// sessionStorage.setItem("cid", this.cjsmqId);
						} else if (this.typecz == 2) {
							this.url = 'http://jxtj.sfjdzx.org.cn/qss1?typeCX=' + this.typecz + '&Encrypt=' + sessionStorage.getItem('Encrypt');
							window.location.href = this.url;
						} else if (this.typecz == 3 || this.typecz == 4) {
							this.url = 'http://jxtj.sfjdzx.org.cn/yqcg1?typeCX=' + this.typecz + '&Encrypt=' + sessionStorage.getItem('Encrypt');
							window.location.href = this.url;
						}
					} else if (res.data.code == 101) {
						this.$message('信息错误');
					} else if (res.data.code == 102) {
						this.$message('信息错误');
					} else if (res.data.code == 103) {
						this.$message('验证码错误');
					}
				},
				err => {}
			);
		},
		// 查询新增
		chaxun() {
			// window.open('http://tpjk-api.bjzjtp.com/uploads/local-storage/9/overdue/30160/136TJ1bH6D7O4Dd8cj2R5MTB45.pdf')
			// return false
			var params = new URLSearchParams();
			if (this.sfzhNum.length > 11) {
				params.append('idnum', this.sfzhNum);
			} else {
				params.append('phone', this.sfzhNum);
			}
			// params.append('idnum', this.sfzhNum);
			params.append('ly_type', 4);
			axios.post(this.HTP + 'online_finance/Arbitration/arbTfzList', params).then(
				res => {
					this.cwxx = false;
					this.qsrsfzh = false;
					if (res.data.code == 200) {
						this.cxrkDiv = false;
						this.cjscmodul = true;
						this.cjsLIst = res.data.data.list;
						this.radioVal = res.data.data.list[0].cid;
						this.rType = res.data.data.list[0].type;
						this.cjsmqId = this.radioVal;
						this.typecz = res.data.data.list[0].type;
						if (res.data.data.type == 1) {
							sessionStorage.setItem('cid', res.data.data.cid);
							// sessionStorage.setItem("Encrypt", res.data.data.Encrypt);
						} else if (res.data.data.type == 2) {
							sessionStorage.setItem('cid', res.data.data.cid);
							// sessionStorage.setItem("Encrypt", res.data.data.Encrypt);
							// this.$router.push({name: 'qss',params: {id: res.data.data.cid}})
						} else if (res.data.data.type == 3) {
							sessionStorage.setItem('cid', res.data.data.cid);
							// sessionStorage.setItem("Encrypt", res.data.data.Encrypt);
							sessionStorage.setItem('typeCX', res.data.data.type);

							// this.$router.push({name: 'yqcg',params: {id: res.data.data.cid}})
						} else if (res.data.data.type == 4) {
							sessionStorage.setItem('cid', res.data.data.cid);
							// sessionStorage.setItem("Encrypt", res.data.data.Encrypt);
							sessionStorage.setItem('typeCX', res.data.data.type);

							// this.$router.push({name: 'yqcg',params: {id: res.data.data.cid}})
						}
					}
					if (res.data.code == 101) {
						this.qsrsfzh = true;
					}
					if (res.data.code == 102) {
						this.cwxx = true;
					}
				},
				err => {}
			);
		},
		// 相关企业核验单选框
		radioChange(val) {
			this.rType = val.type;
			this.radioVal = val.cid;
			this.typecz = val.type;
			sessionStorage.setItem('Encrypt', val.Encrypt);
		}
	},
	mounted() {},
	created() {}
};
</script>

<style lang="less"></style>
